export const DOWNLOAD_SUCCESS_STATE_DURATION = 5000;
export const SESSION_STORAGE_DOWNLOAD_PROGRESS_KEY = 'download-progress';
